module.exports = __webpack_public_path__ + "img/logo.588137a5.png";